<template>
  <footer class="footer">
    <div class="container">
      <ul class="footer__list">
        <li class="footer__item">
          <a class="footer__link" target="_blank"
          href="https://www.mars.com/global/policies/privacy/pp-russian"
          onclick="sendEventYM(
             102182679,
             'confidentiality_click_btn'
           );"
          >Конфиденциальность</a>
        </li>
        <li class="footer__item">
          <a class="footer__link" target="_blank"
          href="https://www.mars.com/cookies-russia"
          onclick="sendEventYM(
             102182679,
             'file_cookies_click_btn'
           );"
          >Файл Cookies</a>
        </li>
        <li class="footer__item">
          <a class="footer__link" target="_blank"
          href="https://www.mars.com/legal-russia"
          onclick="sendEventYM(
             102182679,
             'legal_conditions_click_btn'
           );"
          >Юридические условия</a>
        </li>
        <li class="footer__item">
          <a class="footer__link" target="_blank"
          href="https://www.mars.com/accessibility-russian"
           onclick="sendEventYM(
             102182679,
             'availability_click_btn'
           );"
          >Доступность</a>
        </li>
        <li class="footer__item">
          <a class="footer__link" target="_blank"
          href="/static/docs/Правила Акции ШОВ 2026.pdf"
          onclick="sendEventYM(
             102182679,
             'promotion_rules_click_btn'
           );"
          >Правила акции</a>
        </li>
      </ul>

      <p class="footer__text">&copy;&nbsp;{{ currentYear }} Royal Canin SAS. Все права защищены.</p>
      <p class="footer__text">Входит в&nbsp;группу компаний Mars, Incorporated.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  padding-block: 24px;
  background-color: #333333;

  @media (min-width: $lg) {
    padding-block: 27px;
  }

  & .container {
    @media (min-width: $lg) {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 0 0 20px 0;
    padding: 0;
    list-style: none;

    @media (min-width: $lg) {
      flex-direction: row;
      justify-content: center;
      width: 100%;
    }
  }

  & a.footer__link {
    @include text-16-500;

    color: var(--white);
    text-decoration: none;
    text-underline-offset: 4px;
    transition: $duration $timing-function;

    &:hover {
      text-decoration: underline;
    }
  }

  &__text {
    @include text-3;

    padding-inline: 8px;
    color: var(--white);

    @media (min-width: $lg) {
      padding-inline: 0;
    }
  }
}

</style>
